import React from 'react';
import espiralesSvg from '../images/ilustrations/Anye_espirales.svg';

const positions = [
  { left: '-5%', top: '-2%', size: 700, rotate: -10 },
  // { left: '25%', top: '-5%', size: 680, rotate: 12 },
  { left: '55%', top: '0%', size: 720, rotate: -1 },
  // { left: '80%', top: '-3%', size: 650, rotate: 8 },
  // { left: '-3%', top: '30%', size: 700, rotate: 5 },
  // { left: '35%', top: '28%', size: 620, rotate: -9 },
  // { left: '88%', top: '25%', size: 660, rotate: -14 },
  // { left: '5%', top: '55%', size: 730, rotate: 9 },
  // { left: '45%', top: '58%', size: 670, rotate: -11 },
  // { left: '75%', top: '52%', size: 700, rotate: 6 },
  { left: '-2%', top: '78%', size: 650, rotate: -8 },
  // { left: '30%', top: '82%', size: 690, rotate: 10 },
  // { left: '60%', top: '85%', size: 640, rotate: -12 },
  // { left: '85%', top: '75%', size: 720, rotate: 7 },
];

function SpiralsBg() {
  return (
    <div
      className="SpiralsBg"
      aria-hidden="true"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 20,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
    >
      {positions.map((pos, i) => (
        <img
          key={i}
          src={espiralesSvg}
          alt=""
          className="SpiralsBg-img"
          style={{
            position: 'absolute',
            left: pos.left,
            top: pos.top,
            width: pos.size,
            height: pos.size,
            objectFit: 'contain',
            transform: `rotate(${pos.rotate}deg)`,
          }}
        />
      ))}
    </div>
  );
}

export default SpiralsBg;
